module.exports = __webpack_public_path__ + "img/avax.bcfbb162.png";